import Papa from 'papaparse';

export default {
  data() {
    return {
      mappedFields: [],
      useAvgWeight: false,
      useAvgPrice: false,
      dateFormat: '',
      dateFormats: [
        { label: '30-12-2020', value: 'dd-mm-yyyy'},
        { label: '30-12-20', value: 'dd-mm-yy'},
        { label: '12-30-2020', value: 'mm-dd-yyyy'},
        { label: '12-30-20', value: 'mm-dd-yy'},
        { label: '30/12/2020', value: 'dd/mm/yyyy'},
        { label: '30/12/20', value: 'dd/mm/yy'},
        { label: '12/30/2020', value: 'mm/dd/yyyy'},
        { label: '12/30/20', value: 'mm/dd/yy'}
      ]
    }
  },
  methods: {
    parseFile: function (file, callback) {
      Papa.parse(file, {
        header: true,
        complete: callback,
        skipEmptyLines: true
      });
    },
    parseRemoteFile: function (file, callback) {
      Papa.parse(file, {
        download: true,
        header: true,
        complete: callback,
        skipEmptyLines: true
      });
    },
    fieldMapped(event, field, mappedFields) {
      if(event.target.value != '') {
        let added = mappedFields.findIndex(x => x.field_name == event.target.value);
        let changeField = mappedFields.findIndex(x => x.index == field);
        if(added >= 0){
          mappedFields[added].target.value = '';
          mappedFields.splice(added, 1);
        } else if (changeField >=0) {
          mappedFields.splice(changeField, 1);
        }
        mappedFields.push({
          field_name: event.target.value,
          index: field,
          target: event.target
        });
      } else {
        mappedFields.splice(mappedFields.findIndex(x => x.index == field), 1)
      }
    }
  }
}
